function initializeOfferDetailTicker() {
  if (!document) {
    console.log("document not ready.");
    return;
  }

  const offerContainers = document.querySelectorAll(".offer-detail-bottles");

  if (offerContainers.length === 0) {
    setTimeout(initializeOfferDetailTicker, 3000);
    return;
  }

  let allEmpty = true;
  offerContainers.forEach((container) => {
    const offers = container.querySelectorAll(".offer-item");
    if (offers.length > 0) allEmpty = false;
  });

  if (allEmpty) {
    setTimeout(initializeOfferDetailTicker, 100);
    return;
  }

  offerContainers.forEach((container, index) => {
    const offers = container.querySelectorAll(".offer-item");
    let currentOfferIndex = 0;

    if (offers.length === 0) {
      return;
    }

    offers.forEach((offer, idx) => {
      if (idx === 0) {
        offer.classList.add("active-item");
        offer.classList.remove("hidden-item");
      } else {
        offer.classList.add("hidden-item");
        offer.classList.remove("active-item");
      }
    });

    function switchDetails(offer) {
      const details = Array.from(offer.querySelectorAll(".offer-details > div"));
      if (details.length < 2) return;
      let currentIndex = details.findIndex((detail) => detail.classList.contains("visible-detail"));
      if (currentIndex < 0) currentIndex = 0;
      const nextIndex = (currentIndex + 1) % details.length;
      details[currentIndex].classList.remove("visible-detail");
      setTimeout(() => {
        details[currentIndex].classList.add("hidden-detail");
        details[nextIndex].classList.remove("hidden-detail");
        details[nextIndex].classList.add("visible-detail");
      }, 600);
    }

    const detailDisplayMs = 3000;
    const detailTransitionMs = 600;

    function resetDetails(offer) {
      offer.querySelectorAll(".offer-details > div").forEach((detail, detailIndex) => {
        detail.classList.toggle("visible-detail", detailIndex === 0);
        detail.classList.toggle("hidden-detail", detailIndex !== 0);
      });
    }

    function runOfferCycle() {
      const currentOffer = offers[currentOfferIndex];
      const detailCount = currentOffer.querySelectorAll(".offer-details > div").length;
      for (let detailIndex = 1; detailIndex < detailCount; detailIndex += 1) {
        setTimeout(() => {
          switchDetails(currentOffer);
        }, detailDisplayMs * detailIndex);
      }

      setTimeout(() => {
        if (offers.length < 2) {
          resetDetails(currentOffer);
          runOfferCycle();
          return;
        }
        offers.forEach(offer => {
          offer.classList.remove("active-item");
          offer.classList.add("hidden-item");
        });

        currentOfferIndex = (currentOfferIndex + 1) % offers.length;
        const nextOfferEl = offers[currentOfferIndex];
        resetDetails(nextOfferEl);
        nextOfferEl.classList.remove("hidden-item");
        setTimeout(() => {
          nextOfferEl.classList.add("active-item");
          runOfferCycle();
        }, 300);
      }, detailDisplayMs * detailCount + detailTransitionMs);
    }

    runOfferCycle();
  });
}
